import React from "react";
import CreatableSelect from "react-select/creatable";
import { useFormContext } from "@/providers";
import { DimensionInput, ElevationInput } from "./AirportsComponents";
import { MdQuestionMark } from "react-icons/md";
import Swal from "sweetalert2";


const colourOptions = [
    { value: "Asphalt", label: "Asphalt" },
    { value: "Concrete", label: "Concrete" },
    { value: "Grass", label: "Grass" },
    { value: "Gravel", label: "Gravel" },
    { value: "Ice", label: "Ice" },
    { value: "Sand", label: "Sand" },
    { value: "Snow", label: "Snow" },
    { value: "Water", label: "Water" },
    { value: "Turf", label: "Turf" },
    { value: "Other", label: "Other" },
    { value: "none", label: "None" },
];
const FuelOptions = [
    { value: 'no', label: 'None' },
    { value: '100LL', label: '100LL' },
    { value: 'UL94', label: 'UL94' },
    { value: 'Jet-A', label: 'Jet-A' },
    { value: 'Jet-A1', label: 'Jet-A1' },
    { value: 'Jet-A+', label: 'Jet-A+' },
    { value: 'Jet-B', label: 'Jet-B' },
    { value: 'MoGas', label: 'MoGas' },
    { value: 'other', label: 'Other' },
];;

export const AirportForm = ({ loaders }) => {
    const { setValue, errors, watch, trigger, fieldRefs, handleChange } = useFormContext();

    const airports = watch('airports');

    const handleOrientationInput = (e, index) => {
        let { value } = e.target;
        value = value.replace(/[^\d]/g, "");
        if (value.length > 2) {
            value = value.slice(0, 2) + "/" + value.slice(2);
        }
        if (value.length > 5) {
            value = value.slice(0, 5);
        }
        const fields = [...airports];
        fields[index]["orientation"] = value;
        trigger('airports');
        setValue('airports', fields);
    };

    const handleCloningAirPort = (e, index) => {
        const { name, value } = e.target;
        const fields = [...airports];
        fields[index][name] = value;
        trigger('airports');
        setValue('airports', fields);
        // validateField(name, value, index);
    };

    const addField = (e) => {
        setValue('airports', [
            ...airports,
            {
                airport_identifier: '',
                airport_name: '',
                airport_use: "",
                ctaf_unicom: "",
                dimension_feets: "",
                dimension_meters: "",
                elevation_feets: 0,
                elevation_meters: 0,
                fuel: [],
                lighting: "",
                operation_hours: "",
                orientation: "",
                runway_condition: "",
                parking: "",
                pattern: "",
                surface: [],
                air_nav: '',
                ground_transportation: "",
                distance_from_runway: "",
                additional_info: ''
            },
        ]);
    };

    const removeField = (e, index) => {
        e.preventDefault();
        setValue('airports', airports.filter((_, i) => i !== index));
        // setFormErrorsAirport(errors.filter((_, i) => i !== index));
    };


    return (
        <>
            <div className="grid gap-4 p-4 bg-white rounded-lg md:grid-cols-12">
                <h3 className="flex items-center justify-center text-xl font-bold text-center md:col-span-12">
                    Airport Information <MdQuestionMark
                        onClick={() =>
                            Swal.fire({
                                text: "Any additional information about the airport, kindly put it into the description above",
                                icon: "question",
                            })
                        }
                        style={{ color: "#8ec639", cursor: "pointer" }}
                    />
                </h3>

                {airports?.map((field, index) => (
                    <React.Fragment key={index}>
                        <div className="text-left md:col-span-4">
                            <label className="flex items-center">Identifier
                                <MdQuestionMark
                                    onClick={() =>
                                        Swal.fire({
                                            text: "Please enter the 2- to 4-digit identifier OR specify if it’s a private runway, water landing, etc.",
                                            icon: "question",
                                        })
                                    }
                                    style={{ color: "#8ec639", cursor: "pointer" }}
                                />
                            </label>
                            <input
                                type="text"
                                placeholder="Identifier"
                                name="airport_identifier"
                                className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                                value={field.airport_identifier}
                                ref={(el) => (fieldRefs.current[`airports.${index}.airport_identifier`] = el)}
                                onChange={(e) => handleCloningAirPort(e, index)}
                            />
                            {errors?.airports?.[index]?.airport_identifier && (
                                <p style={{ color: "red" }}>
                                    {errors?.airports?.[index]?.airport_identifier.message}
                                </p>
                            )}
                        </div>
                        <div className="text-left md:col-span-4">
                            <label>Airport Name</label>
                            <input
                                type="text"
                                placeholder="Airport Name"
                                name="airport_name"
                                className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                                value={field.airport_name}
                                ref={(el) => (fieldRefs.current[`airports.${index}.airport_name`] = el)}
                                onChange={(e) => handleCloningAirPort(e, index)}
                            />
                            {errors?.airports?.[index]?.airport_name && (
                                <p style={{ color: "red" }}>
                                    {errors?.airports?.[index]?.airport_name.message}
                                </p>
                            )}
                        </div>
                        <div className="text-left md:col-span-4">
                            <label>Airport Use</label>
                            <select
                                value={field.airport_use}
                                name="airport_use"
                                ref={(el) => (fieldRefs.current[`airports.${index}.airport_use`] = el)}
                                onChange={(e) => handleCloningAirPort(e, index)}
                                className="w-full gap-4 px-3 py-3 border rounded-md border-input"
                            >
                                <option value="">Airport Use</option>
                                <option value="Public">Public</option>
                                <option value="Private">Private</option>
                                <option value="Private - permission required to land">
                                    Private - permission required to land
                                </option>
                            </select>
                            {errors?.airports?.[index]?.airport_use && (
                                <p style={{ color: "red" }}>
                                    {errors?.airports?.[index]?.airport_use?.message}
                                </p>
                            )}
                        </div>
                        <div className="text-left md:col-span-4">
                            <label>Operation Hours</label>
                            <input
                                type="text"
                                placeholder="Operation Hours"
                                name="operation_hours"
                                ref={(el) => (fieldRefs.current[`airports.${index}.operation_hours`] = el)}
                                className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                                value={field.operation_hours}
                                onChange={(e) => handleCloningAirPort(e, index)}
                            />
                            {errors?.airports?.[index]?.operation_hours && (
                                <p style={{ color: "red" }}>
                                    {errors?.airports?.[index]?.operation_hours?.message}
                                </p>
                            )}
                        </div>
                        <div className="text-left md:col-span-4">
                            <label>Lighting</label>
                            <div className="listsearch-input-item">
                                <select
                                    value={field.lighting}
                                    name="lighting"
                                    ref={(el) => (fieldRefs.current[`airports.${index}.lighting`] = el)}
                                    onChange={(e) => handleCloningAirPort(e, index)}
                                    className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                                >
                                    <option disabled value="">
                                        select
                                    </option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                                {errors?.airports?.[index]?.lighting && (
                                    <p style={{ color: "red" }}>
                                        {errors?.airports?.[index]?.lighting?.message}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="text-left md:col-span-4">
                            <label>CTAF/UNICOM</label>
                            <input
                                type="text"
                                placeholder="CTAF/UNICOM"
                                name="ctaf_unicom"
                                ref={(el) => (fieldRefs.current[`airports.${index}.ctaf_unicom`] = el)}
                                value={field.ctaf_unicom}
                                className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                                onChange={(e) => handleCloningAirPort(e, index)}
                            />
                            {errors?.airports?.[index]?.ctaf_unicom && (
                                <p style={{ color: "red" }}>
                                    {errors?.airports?.[index]?.ctaf_unicom?.message}
                                </p>
                            )}
                        </div>
                        <div className="text-left md:col-span-6">
                            <label>Fuel</label>
                            <CreatableSelect
                                styles={{
                                    input: (base) => ({
                                        ...base,
                                        margin: 0,

                                    })
                                }}
                                ref={(el) => (fieldRefs.current[`airports.${index}.fuel`] = el)}
                                value={FuelOptions.filter(option => field.fuel.includes(option.value))}
                                onChange={(selectedFuel) => {
                                    const fields = [...airports];
                                    const selectedFuelValues = selectedFuel.map((option) => {
                                        // Add new custom options to FuelOptions
                                        if (!FuelOptions.some((existingOption) => existingOption.value === option.value)) {
                                            FuelOptions.push(option);
                                        }
                                        return option.value;
                                    });
                                    fields[index]["fuel"] = selectedFuelValues;
                                    setValue('airports', fields);
                                    trigger('airports');
                                }}
                                onCreateOption={(inputValue) => {
                                    const newOption = { value: inputValue, label: inputValue };
                                    FuelOptions.push(newOption); // Add the new option to FuelOptions
                                    const fields = [...airports];
                                    fields[index]["fuel"] = [...fields[index]["fuel"], inputValue];
                                    setValue('airports', fields);
                                    trigger('airports');
                                }}
                                isMulti
                                options={FuelOptions}
                            />

                            {errors?.airports?.[index]?.fuel && (
                                <p style={{ color: "red" }}>{errors?.airports?.[index]?.fuel?.message}</p>
                            )}
                        </div>

                        <div className="text-left md:col-span-6">
                            <label>Parking</label>
                            <div className="listsearch-input-item">
                                <select
                                    value={field.parking}
                                    name="parking"
                                    ref={(el) => (fieldRefs.current[`airports.${index}.parking`] = el)}
                                    onChange={(e) => handleCloningAirPort(e, index)}
                                    className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                                >
                                    <option value="">Select Parking</option>
                                    <option value="Hangar">Hangar</option>
                                    <option value="Hangar and Tie-downs">
                                        Hangar and Tie-downs
                                    </option>

                                    <option value="Tie-downs">Tie-downs</option>
                                    <option value="Bring your own tie-downs">Bring your own tie-downs</option>
                                    <option value="Mooring at the house">Mooring at the house</option>

                                </select>
                                {errors?.airports?.[index]?.parking && (
                                    <p style={{ color: "red" }}>
                                        {errors?.airports?.[index]?.parking?.message}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="text-left md:col-span-6">
                            <label>Orientation</label>
                            <input
                                type="text"
                                placeholder="Orientation"
                                name="orientation"
                                ref={(el) => (fieldRefs.current[`airports.${index}.orientation`] = el)}
                                className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                                value={field.orientation}
                                onChange={(e) => handleOrientationInput(e, index)}
                                maxLength={5}
                                pattern="\d{2}/\d{2}"
                            />
                            {errors?.airports?.[index]?.orientation && (
                                <p style={{ color: "red" }}>
                                    {errors?.airports?.[index]?.orientation?.message}
                                </p>
                            )}
                        </div>
                        <div className="text-left md:col-span-6">
                            <DimensionInput
                                index={index}
                            />
                        </div>

                        <div className="text-left md:col-span-6">
                            <label>Surface</label>

                            <CreatableSelect
                                styles={{
                                    input: (base) => ({
                                        ...base,
                                        margin: 0,

                                    }),
                                    option: (baseStyles, state) => ({
                                        ...baseStyles,
                                        position: "relative",
                                        zIndex: 100,
                                    }),
                                }}
                                ref={(el) => (fieldRefs.current[`airports.${index}.surface`] = el)}
                                value={colourOptions.filter(option => field.surface.includes(option.value))}
                                onChange={(selectedSurface) => {
                                    const fields = [...airports];
                                    const selectedSurfaceValues = selectedSurface.map((option) => {
                                        // Add new custom options to colourOptions
                                        if (!colourOptions.some((existingOption) => existingOption.value === option.value)) {
                                            colourOptions.push(option);
                                        }
                                        return option.value;
                                    });
                                    fields[index]["surface"] = selectedSurfaceValues;
                                    setValue('airports', fields);
                                    trigger('airports');
                                }}
                                onCreateOption={(inputValue) => {
                                    const newOption = { value: inputValue, label: inputValue };
                                    colourOptions.push(newOption); // Add the new option to colourOptions
                                    const fields = [...airports];
                                    fields[index]["surface"] = [...fields[index]["surface"], inputValue];
                                    setValue('airports', fields);
                                    trigger('airports');
                                }}
                                isMulti
                                options={colourOptions}
                            />

                            {errors?.airports?.[index]?.surface && (
                                <p style={{ color: "red" }}>
                                    {errors?.airports?.[index]?.surface?.message}
                                </p>
                            )}
                        </div>

                        <div className="text-left md:col-span-6">
                            <label>Condition</label>
                            <input
                                type="text"
                                placeholder="Condition"
                                name="runway_condition"
                                ref={(el) => (fieldRefs.current[`airports.${index}.runway_condition`] = el)}
                                className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                                value={field.runway_condition}
                                onChange={(e) => handleCloningAirPort(e, index)}
                            />
                            {errors?.airports?.[index]?.runway_condition && (
                                <p style={{ color: "red" }}>
                                    {errors?.airports?.[index]?.runway_condition?.message}
                                </p>
                            )}
                        </div>

                        <div className="text-left md:col-span-6">
                            <label>Pattern</label>
                            <div className="listsearch-input-item">
                                <select
                                    value={field.pattern}
                                    name="pattern"
                                    ref={(el) => (fieldRefs.current[`airports.${index}.pattern`] = el)}
                                    onChange={(e) => handleCloningAirPort(e, index)}
                                    className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                                >
                                    <option value="">Select Pattern</option>
                                    <option value="left, left">left, left</option>
                                    <option value="left, right">left, right</option>
                                    <option value="right, left">right, left</option>
                                    <option value="right, right">right, right</option>
                                </select>
                                {errors?.airports?.[index]?.pattern && (
                                    <p style={{ color: "red" }}>
                                        {errors?.airports?.[index]?.pattern?.message}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="text-left md:col-span-6">
                            <ElevationInput
                                index={index}
                            />
                        </div>

                        <div className="text-left md:col-span-6">
                            <label>Distance from Runway to Accommodations</label>
                            <div className="listsearch-input-item">
                                <select
                                    value={parseInt(field.distance_from_runway)}
                                    name="distance_from_runway"
                                    ref={(el) => (fieldRefs.current[`airports.${index}.distance_from_runway`] = el)}
                                    onChange={(e) => handleCloningAirPort(e, index)}
                                    className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                                >
                                    <option value={-1}>Select Distance</option>
                                    <option value={0}>0 miles</option>
                                    <option value={1}>0 to 1 miles</option>
                                    <option value={3}>1.1 to 3 miles</option>
                                    <option value={7}>3.1 to 7 miles</option>
                                    <option value={8}>7+ miles</option>
                                </select>
                                {errors?.airports?.[index]?.distance_from_runway && (
                                    <p style={{ color: "red" }}>
                                        {errors?.airports?.[index]?.distance_from_runway?.message}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="text-left md:col-span-6">
                            <label>Airnav.com Information</label>
                            <input
                                type="text"
                                placeholder="https://airnav.com/airport/"
                                name="air_nav"
                                ref={(el) => (fieldRefs.current[`airports.${index}.air_nav`] = el)}
                                className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                                value={field.air_nav || "https://airnav.com/airport/"}
                                onChange={(e) => handleCloningAirPort(e, index)}
                            />
                            {errors?.airports?.[index]?.air_nav && (
                                <p style={{ color: "red" }}>
                                    {errors?.airports?.[index]?.air_nav?.message}
                                </p>
                            )}
                        </div>
                        <div className="text-left md:col-span-6">
                            <ul className="flex items-center gap-4 px-3 py-3 mt-5 border rounded-md border-input">
                                <input
                                    className="instant_check_box"
                                    ref={(el) => (fieldRefs.current[`helicopter_allowed`] = el)}
                                    id="check-aaa51"
                                    type="checkbox"
                                    style={{ padding: '10px' }}
                                    name="helicopter_allowed"
                                    value={parseInt(watch('helicopter_allowed')) || 0}
                                    checked={parseInt(watch('helicopter_allowed')) === 1}
                                    onChange={handleChange}
                                />
                                <label htmlFor="check-aaa51 !m-0">
                                    Allow <strong>Helicopter </strong>
                                </label>
                            </ul>
                            {errors.instant_booking && (
                                <span style={{ color: "red" }}>
                                    {errors.instant_booking?.message}
                                </span>
                            )}
                        </div>

                        <div className="text-left dashboard-title md:col-span-12">
                            <h4>Ground Transportation</h4>
                        </div>
                        <div className="text-left md:col-span-6">
                            <select
                                value={field.ground_transportation}
                                name="ground_transportation"
                                ref={(el) => (fieldRefs.current[`airports.${index}.ground_transportation`] = el)}
                                onChange={(e) => handleCloningAirPort(e, index)}
                                className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                            >
                                <option value="">Select Transportation</option>
                                <option value="We have a courtesy vehicle waiting for you!">
                                    We have a courtesy vehicle  waiting for you!
                                </option>
                                <option value="We have a vehicle you can rent from us!">
                                    We have a vehicle you can rent from us!
                                </option>
                                <option value="Rent a vehicle right in the airport! Their phone number is:">
                                    Rent a vehicle right in the airport! Their phone number is:
                                </option>
                                <option value="We will give you a ride to the nearest rental vehicle agency!">
                                    We will give you a ride to the nearest rental vehicle agency!
                                </option>
                                <option value="We have a deal with the FBO so you can keep the vehicle your whole stay!">
                                    We have a deal with the FBO so you can keep the vehicle your whole
                                    stay!
                                </option>
                                <option value="You don't need a vehicle here!">
                                    You don't need a vehicle here!
                                </option>
                            </select>
                            {errors?.airports?.[index]?.ground_transportation && (
                                <p style={{ color: "red" }}>
                                    {errors?.airports?.[index]?.ground_transportation?.message}
                                </p>
                            )}
                        </div>

                        <div className="text-left md:col-span-6">
                            <input
                                type="text"
                                placeholder="Additional Information"
                                name="additional_info"
                                className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                                value={field.additional_info}
                                ref={(el) => (fieldRefs.current[`airports.${index}.additional_info`] = el)}
                                onChange={(e) => handleCloningAirPort(e, index)}
                            />
                            {errors?.airports?.[index]?.additional_info && (
                                <p style={{ color: "red" }}>
                                    {errors?.airports?.[index]?.additional_info?.message}
                                </p>
                            )}
                        </div>

                        <div className="flex items-start justify-start md:col-span-12">
                            {airports?.length > 1 && (
                                <button
                                    className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
                                    onClick={(e) => removeField(e, index)}
                                >
                                    Remove
                                </button>
                            )}
                        </div>

                        <div className="flex items-end justify-end text-left md:col-span-12">
                            <button
                                type="button"
                                onClick={addField}
                                className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
                            >
                                Add Airport
                            </button>
                        </div>
                    </React.Fragment>
                ))}


            </div>
        </>

    );
};
